import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { makeStyles } from '@material-ui/core/styles';
import { Section, Panel, Badge } from './shared';
import { SEVERITY_COLORS, SEVERITY_ICONS, SEVERITY_TONES } from './severity';
import { formatCount } from '../utils';

const useStyles = makeStyles(theme => ({
  item: {
    display: 'grid', gridTemplateColumns: '4px auto 1fr auto auto', alignItems: 'center', gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2), marginTop: theme.spacing(1), border: '1px solid var(--dm-border, #e7ebf0)', borderRadius: 12,
    '&:first-child': { marginTop: 0 },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '4px auto minmax(0, 1fr)',
      alignItems: 'start',
      gap: theme.spacing(1),
      padding: theme.spacing(1.25),
      '& $bar': { gridRow: '1 / 3' },
      '& $count': { gridColumn: 2, alignSelf: 'center' },
      '& $action': { gridColumn: 3, width: '100%', whiteSpace: 'normal' },
    },
  },
  bar: { width: 4, alignSelf: 'stretch', borderRadius: 4 },
  title: { fontSize: '0.84rem', fontWeight: 700 },
  detail: { color: 'var(--dm-muted, #647184)', fontSize: '0.75rem', lineHeight: 1.45 },
  action: { whiteSpace: 'nowrap' },
  count: { display: 'inline-flex' },
  healthy: { display: 'flex', gap: 10, alignItems: 'center', color: '#15803d', padding: theme.spacing(2) },
}));

/** `attention[]` in the order the API sorted it (most serious first). */
const AttentionList = ({ id = 'attention', items = [], onAction, exportKey }) => {
  const classes = useStyles();
  return (
    <Section id={id} title="Needs attention" exportKey={exportKey} action={<Badge tone={items.length ? 'amber' : 'green'}>{formatCount(items.length)}</Badge>}>
      <Panel>
        {items.length ? items.map(item => {
          const color = SEVERITY_COLORS[item.severity] || SEVERITY_COLORS.info;
          const Icon = SEVERITY_ICONS[item.severity] || SEVERITY_ICONS.info;
          return (
            <article key={item.key} className={classes.item} data-testid={`attention-${item.key}`}>
              <span className={classes.bar} style={{ background: color }} />
              <Icon style={{ color }} aria-label={item.severity} />
              <div style={{ minWidth: 0 }}><Typography className={classes.title}>{item.title}</Typography><Typography className={classes.detail}>{item.detail}</Typography></div>
              <span className={classes.count}><Badge tone={SEVERITY_TONES[item.severity] || 'blue'}>{formatCount(item.count)}</Badge></span>
              {item.action?.label && onAction ? (
                <Button className={classes.action} size="small" variant="outlined" color="primary" onClick={() => onAction(item)}>{item.action.label}</Button>
              ) : <span />}
            </article>
          );
        }) : <div className={classes.healthy}><CheckCircleOutlineIcon /><Typography style={{ fontWeight: 700 }}>No checks found a problem</Typography></div>}
      </Panel>
    </Section>
  );
};

export default AttentionList;
